import SignIn, { PATH as SIGN_IN } from './SignIn'
import Register, { PATH as REGISTER } from './Register'
import SendMailResetPassword, {
  PATH as SEND_MAIL_RESET_PASSWORD,
} from './SendMailResetPassword'
import ResetPassword, { PATH as RESET_PASSWORD_PATH } from './ResetPassword'
import ResetPasswordComplete, {
  PATH as COMPLETE_PAGE,
} from './ResetPasswordComplete'
import RegistrationComplete, {
  PATH as REGISTRATION_COMPLETE,
} from './RegistrationComplete'
import LinkLine, { PATH as LINK_LINE } from './LinkLine'
import MedicalSpecialty, { PATH as MEDICAL_SPECIALTY } from './MedicalSpecialty'
import Registered, { PATH as REGISTERED } from './Registered'
import PrecautionModalPlan, {
  PATH as PRECAUTION_MODAL_PLAN,
} from './PrecautionModalPlan'
import PrecautionModalOnline, {
  PATH as PRECAUTION_MODAL_ONLINE,
} from './PrecautionModalOnline'
import CheckUserExistsModal, {
  PATH as CHECK_USER_EXISTS_MODAL,
} from './CheckUserExistsModal'
import SendMailSettingPasswordPage, {
  PATH as SEND_MAIL_SETTING_PASSWORD,
} from './SendMailSettingPassword'
import SettingPassword, {
  PATH as SETTING_PASSWORD_PATH,
} from './SettingPassword'
import Contact, { PATH as CONTACT } from './Contact'
import LineLink, { PATH as LINE_LINK } from './LineLink'

export default {
  SignIn,
  Register,
  SendMailResetPassword,
  ResetPassword,
  ResetPasswordComplete,
  RegistrationComplete,
  LinkLine,
  MedicalSpecialty,
  Registered,
  PrecautionModalPlan,
  PrecautionModalOnline,
  CheckUserExistsModal,
  SettingPassword,
  SendMailSettingPasswordPage,
  Contact,
  LineLink,
}
export const PATH = {
  SIGN_IN,
  REGISTER,
  SEND_MAIL_RESET_PASSWORD,
  RESET_PASSWORD_PATH,
  COMPLETE_PAGE,
  REGISTRATION_COMPLETE,
  LINK_LINE,
  MEDICAL_SPECIALTY,
  REGISTERED,
  PRECAUTION_MODAL_PLAN,
  PRECAUTION_MODAL_ONLINE,
  CHECK_USER_EXISTS_MODAL,
  SETTING_PASSWORD_PATH,
  SEND_MAIL_SETTING_PASSWORD,
  CONTACT,
  LINE_LINK,
}
